export default {
  // 加載提示
  loading: "拼命加載中",

  // 暫無數據
  noData: "暫無數據",

  // 標題
  pendingSurvey: "待調證",
  completedSurvey: "已調證",

  // 字段標籤
  platform: "平台：",
  platformColon: "平台:",
  surveyContent: "調證內容：",
  uid: "UID:",
  name: "姓名：",
  address: "地址：",

  // 按鈕
  uploadSurvey: "上傳調證",
  downloadSurveyContent: "下載調證內容",
  dataSync: "數據同步",

  // 消息提示
  messageTitle: "消息",
  dataSyncing: "數據同步中，請稍後查看",

  // 文件名
  dataFileName: "數據",
};
